export const ISO_DATE_REGEX =
  /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d*)?Z$/;

export const isIsoDateString = (value: unknown): boolean => {
  if (value === null || value === undefined) return false;
  if (typeof value !== 'string') return false;
  return ISO_DATE_REGEX.test(value);
};

/** Finds and converts ISOString dates in the target object into Date instances.
 * Modification is done **in-place**!
 * @param body the object to modify in-place. */
export const convertIsoStringToDate = <T>(body: T): T => {
  if (body === null || body === undefined || typeof body !== 'object') {
    return body;
  }
  const assertedBody = body as Record<string, unknown>;
  for (const key of Object.keys(assertedBody)) {
    const value = assertedBody[key];
    if (isIsoDateString(value)) {
      assertedBody[key] = new Date(value as string);
    } else if (typeof value === 'object') {
      convertIsoStringToDate(value);
    }
  }
  return body;
};
